/* eslint-disable max-len */
// production invent-app environment
export const environment = {
	production: true,
	firebase: {
		apiKey: "AIzaSyDkCUUocbGXRaXu6LGtWPB5DWYVWtQN3qI",
		authDomain: "invent-app-prd.firebaseapp.com",
		databaseURL: "https://invent-app-prd-default-rtdb.europe-west1.firebasedatabase.app",
		projectId: "invent-app-prd",
		storageBucket: "invent-app-prd.appspot.com",
		messagingSenderId: "60391637160",
		appId: "1:60391637160:web:b533d51f31667a1a7cc29d",
		measurementId: "G-CVDX6MQDSX"
	},
	platform: {
		appName: "FEHAP 2025",
		apiBaseUrl: "https://europe-west3-invent-app-prd.cloudfunctions.net/",
		apiV2BaseUrl: "-gka7oavk2a-ey.a.run.app",
		oneSignalAppId: "a1a44a7b-8fdb-4704-83cf-eacc1cff82b0",
		oneSignalApiId: "YjI0NDMwNTEtZTUzZS00N2MwLTk4YjQtYWVmZDhiNzJhZTY5",
		defaultLanguage: "FrFR", // FrFR EnUS DeDE PtBR EsES ArAR
		defaultTimezone: "Europe/Paris", // Europe/Paris America/Sao_Paulo
		region: "europe-west3",
		dateFormat: "EEEE dd-MM-yyyy • HH:mm",
		locale: "fr-FR", // fr-FR en-US de-DE pt-BR es-ES
		loginLogoClass: "invent-logo", // options is 'banner-logo' or 'invent-logo'
		containerId: "7YbDiAH2dFPC55uwW7Bv", // defaultContainer or id of container
		persistence: true,
		version: "3.9.80",
		sparkupDefaultUrl: "https://demo.sparkup.live/connect/INVEN",
		tinyMce: {
			init: {
				base_url: "/tinymce", // Root for resources
				suffix: ".min",
				height: 450,
				menubar: false,
				plugins: "code paste lists media image",
				toolbar: [
					"code | paste pastetext | undo redo | bold italic underline strikethrough | numlist bullist | image media",
					"formatselect fontselect fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify"
				],
				valid_elements: "*[*]"
			},
			initMobile: {
				mobile: {
					base_url: "/tinymce", // Root for resources
					suffix: ".min",
					menubar: true,
					theme: "mobile",
					plugins: "autosave lists autolink",
					toolbar: "undo bold italic styleselect"
				}
			},
			initNothing: {
				base_url: "/tinymce", // Root for resources
				suffix: ".min",
				// height: 450,
				min_height: 150,
				max_height: 450,
				menubar: false,
				plugins: ["autoresize", "lists", "quickbars"],
				toolbar: [],
				quickbars_selection_toolbar: "bold italic underline | blocks | bullist numlist | blockquote",
				valid_elements: "*[*]"
			}
		},
		recaptchaSettings: {
			easy: { siteKey: "6LdW_uchAAAAAGLh_eg8siZa4YsTOTOIAbSmMkKZ" },
			medium: { siteKey: "6LfII9shAAAAAOmGxtQFgg_KFt1EVeVl_o-t50JB" },
			hard: { siteKey: "6Lfer-IhAAAAAOv3VJ8Rua3p1GaZAEtkJj2PXF_N" }
		},
		recaptchaV3Settings: { siteKey: "6Lewt6khAAAAAJsxDiwBLYKDBsKk0IpKaW9ZHhvf" },
		googleMapApiKey: "AIzaSyAOhR7K9nZ0INeOIR_SL8bE5xzP2sV84do",
		optimisationEvent: true,
		encryptKey: "sTVH798NkDsPikbfHL7JRsgEeY336kGE",
		ssoToken: "LH161D030ho7m6rGlcFV7buGCC7DdXdJ",
		saveFileVersion: 1,
		appointments: {
			"confirmed-rdv-icon":
				"https://firebasestorage.googleapis.com/v0/b/invent-app-prd.appspot.com/o/rdv-confirmed-icon.png?alt=media&token=477c1773-7685-4cf3-b16f-b835a47f0ff5",
			"cancelled-rdv-icon":
				"https://firebasestorage.googleapis.com/v0/b/invent-app-prd.appspot.com/o/rdv-cancelled-icon.png?alt=media&token=868258c3-ad43-41af-91ee-c168bbaf8b27"
		}
	}
};
